import { Carriers } from "@redotech/redo-fulfillment-carrier-common/carrier-service-enums";
import { inventoryItemIdFormat } from "@redotech/redo-inventory-id";
import { productIdFormat } from "@redotech/redo-product-id";
import { storageLocationIdFormat } from "@redotech/redo-warehouse-id";
import * as z from "zod";

export const fulfillBinsAsManualGroup = {
  name: "fulfillBinsAsManualGroup" as const,
  input: z.object({
    storageLocationIds: z.array(storageLocationIdFormat.schema).min(1),
    orderName: z.string().trim().min(1),
    carrier: z.enum(Carriers).optional(),
    trackingNumber: z.string().trim().optional(),
    destination: z
      .object({
        name: z.string().trim().min(1),
        company: z.string().optional(),
        address1: z.string().optional(),
        city: z.string().optional(),
        province: z.string().optional(),
        zip: z.string().optional(),
        countryCode: z.string().optional(),
      })
      .optional(),
    lines: z
      .array(
        z.object({
          productId: productIdFormat.schema,
          inventoryItemId: inventoryItemIdFormat.schema.nullable(),
          allocations: z
            .array(
              z.object({
                storageLocationId: storageLocationIdFormat.schema,
                quantity: z.number().int().positive(),
              }),
            )
            .min(1),
        }),
      )
      .min(1),
  }),
  output: z.object({
    fulfillmentGroupId: z.string(),
    transferSessionId: z.string(),
    unitsFulfilled: z.number(),
  }),
};
